const PhoneSystemTerms = () => (
  <div>
    <h3 className="tw-font-semibold tw-mt-0">Phone System Terms of Use</h3>
    <p>
      Brivity provides the Phone System as an add on service. If you purchase this service you will receive
      access to a customized Phone System that integrates directly with the Brivity Platform, providing the
      ability to route and track inbound calls. You will be provided with a specific number of tracking
      numbers, minutes per month, and cost for minutes in excess of the designated amount of minutes per month
      in accordance with the specific Phone System plan you selected at the time of purchase. Additional add
      on options for more tracking numbers may be available for purchase depending on your plan. You also have
      access to additional features and tools made available through the Phone System, including phone call
      recordings and transcripts for your inbound calls. Certain countries, states, and jurisdictions require
      the consent of all parties to record telephone conversations. If you disable the notification feature
      and subsequently record telephone conversations without providing proper notice and consent, you may be
      in violation of federal and/or state law. You agree that you are solely responsible for using the call
      recording and transcription features associated with the Phone System service in accordance with all
      applicable laws and regulations.
    </p>
    <p>
      You agree that the credit card on file for your Brivity Platform subscription will be charged until you
      terminate your Phone System plan subscription and that you have the authority to authorize charges on
      the credit card and accept the Terms of Service and Privacy Policy related to your purchase. Your credit
      card will be charged a pro-rated amount for the first month up until your regularly scheduled Brivity
      Platform recurring monthly billing date. Thereafter, your credit card will be charged monthly for the
      Phone System service plan at the same time as your recurring monthly billing date for your Brivity
      Platform subscription. You may terminate or modify your Phone System service plan at any time by
      reaching out to Brivity Support at (855) 427-4848. Upon termination, you will not be charged your next
      recurring payment, and your access to the Phone System service will cease at your next Brivity Platform
      recurring bill date. No refunds or pro-rated rebates will be given if you cancel prior to your recurring
      monthly billing date. Upon termination of your plan, you may choose which numbers assigned to you that
      you want to maintain and port away. It is your responsibility to notify us of any numbers you intend to
      port away. The porting process is driven by your carrier and the account owner will need to provide
      permission for each number to be ported away. Your account must remain active until the port away
      process is complete. Any numbers not ported away before you terminate may not be available to you at a
      later time. Further, upon termination, call recordings and transcripts will no longer be accessible to
      you.
    </p>
    <p>
      By selecting the checkbox below and proceeding with the purchase, the Brivity account owner agrees
      without reservation or limitation to defend, indemnify and hold harmless Brivity, Inc. and its
      affiliates and their respective directors, officers, employees and agents from and against any and all
      losses, damages, claims, liabilities, fines, judgments, settlements, actions, suits, proceedings,
      litigation, investigations, legal costs and expenses and demands made by any party due to or arising out
      of the use of Brivity’s Platform and Services (including the Brivity Phone System) by the Brivity
      account owner and/or his, her or its employees, agents, affiliates or representatives using the Brivity
      account.
    </p>
  </div>
);

export default PhoneSystemTerms;
